<script>
	import CaseStudy from '$lib/Components/CaseStudy/CaseStudy.svelte';
	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Grid from '$lib/Components/Layout/Grid/Grid.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import CustomizeYourInsert from '$lib/PageSections/CustomizeYourInsert/CustomizeYourInsert.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';

	import all from './images/all.jpg';
	import drafts from './images/drafts.jpg';
	import insulation from './images/insulation.webp';
	import lights from './images/lights.jpg';
	import noise from './images/noise.jpg';

	// images
</script>

<Section backgroundColor={'white'}>
	<h2>The Best Way to Insulate Windows</h2>
	<p>
		Want to know how to insulate windows? Indow inserts are an easy, immediate,
		reversible solution to: cold drafts, noise, hot summer air, and fading
		hardwood floors. Indow uses precise laser measurements to create custom
		inserts.
	</p>
	<p>
		Every insert fits your window precisely – even if your window is odd-shaped.
		We use durable acrylic panels, which insulate better than glass, surrounded
		by compression tubing so inserts fit snugly in place. This combination is
		the best way to insulate windows. Indow inserts don’t just insulate against
		drafts and noise. You can choose privacy or UV protection. Look through our
		solutions below to find the best window inserts for your needs.
	</p>

	<Grid columns={2} rows={4} center>
		<Grid subgrid vertical>
			<CaseStudy
				title="Drafts & Savings"
				href="/solutions/insulating-drafty-windows/"
				src={drafts}
				alt="Indow insulating windows."
				description="The best way to insulate windows against cold, summer heat, and save on energy bills.These inserts seal out drafts, insulating windows against cold while providing some noise reduction."
				learnMore
				subgrid
			/>
		</Grid>
		<Grid subgrid vertical>
			<CaseStudy
				title="Noise"
				href="/solutions/window-noise-reduction/"
				src={noise}
				alt="Indow insulating windows"
				description="Our acoustic panels insulate against drafts and have increased noise reduction abilities. These inserts are insulating windows against outside noise to create a quiet, more soundproof environment."
				learnMore
				subgrid
			/>
		</Grid>
	</Grid>

	<hr />
	<Grid columns={2} rows={4} center>
		<Grid subgrid vertical>
			<CaseStudy
				title="Lights & UV"
				href="/solutions/light-uv/"
				src={lights}
				alt="Indow insulating windows."
				description="In addition to insulating windows, our these inserts obscure light for privacy, block UV light for protection, or completely blackout a room for a dark, quiet sleep environment."
				learnMore
				subgrid
			/>
		</Grid>
		<Grid subgrid vertical>
			<CaseStudy
				title="All Products"
				href="/custom-storm-windows/"
				src={all}
				alt="Indow insulating windows."
				description="All custom-made Indow inserts are great at insulating windows against drafts and noise. Different grades have additional insulating powers. See all our grade types to find the best window inserts for your situation."
				learnMore
				subgrid
			/>
		</Grid>
	</Grid>
</Section>

<Awards />
<CustomizeYourInsert />

<Section backgroundColor={'white'}>
	<h2>Insulating Windows is Easy</h2>
	<p>
		Indow window insulation inserts are custom made to fit your window perfecty.
		When they arrive, all you have to do is press them in to place to start
		insulating your windows. Our window inserts install in minutes with no
		mounting hardware. And depending on their size, you only need one person to
		put them in place.
	</p>

	<Image src={insulation} alt="Man installing window insulation inserts." />
	<Bubble
		backgroundColor="transparent"
		title="How to Insulate Windows with Indow Inserts:"
	>
		<ul>
			<li>Acrylic panels insulate against cold better than glass</li>
			<li>
				Silicone tubing creates an almost airtight barrier because of its
				compression abilities
			</li>
			<li>
				Dead air space between the acrylic panel & the glass adds more
				insulation
			</li>
			<li>Dead air space & acrylic also insulate against noise</li>
		</ul>
	</Bubble>

	<p>
		All of this means saving money from lowered energy costs. By insulating
		windows with our inserts, you also preserve your existing windows. The
		inserts press inside your window frame with no construction needed, ready to
		insulate immediately.
	</p>
</Section>

<Reviews />
<GetAFreeEstimate />
